import { getTicketsNavState } from '@/lib/tickets-nav'

const ROUTE_TITLES: Record<string, string> = {
  '/tickets': 'Все обращения',
  '/ai-tickets': 'Мозгобот',
  '/dashboard': 'Дашборд',
  '/analytics': 'Аналитика',
  '/analytics-new': 'Аналитика New',
  '/bookmarks': 'Закладки',
  '/filters': 'Фильтры',
  '/reviews': 'Оценки и отзывы',
  '/quality': 'АРМ Качества',
  '/failed-deliveries': 'Недоставленные',
  '/installers': 'Установщики',
  '/users': 'Пользователи',
  '/operators': 'Операторы',
  '/schedules': 'Табель',
  '/emergency-mode': 'Аварийный режим',
  '/macros': 'Макросы',
  '/settings': 'Настройки',
  '/knowledge-base': 'База знаний',
  '/anomalies': 'Аномалии',
  '/actualization': 'Актуализация',
  '/activity-log': 'Лог действий',
}

const STATUS_LABELS: Record<string, string> = {
  resolved: 'Решённые',
  closed: 'Закрытые',
  emergency: 'Авария',
}

/** Заголовок вкладки по текущему URL */
export function getWorkspaceTabTitle(pathname: string, search: string): string {
  const sp = search || ''
  if (pathname === '/tickets' || pathname === '/ai-tickets') {
    const nav = getTicketsNavState(pathname, sp)
    if (pathname === '/ai-tickets') return 'Мозгобот'
    if (nav.urlFilterName) return `Фильтр · ${nav.urlFilterName}`
    if (nav.urlProject) {
      const st = nav.urlStatus ? STATUS_LABELS[nav.urlStatus] || nav.urlStatus : null
      return st ? `${nav.urlProject} · ${st}` : `Проект · ${nav.urlProject}`
    }
    if (nav.urlStatus) {
      return `Обращения · ${STATUS_LABELS[nav.urlStatus] || nav.urlStatus}`
    }
    return 'Все обращения'
  }

  if (pathname === '/debug') {
    const q = sp.startsWith('?') ? sp.slice(1) : sp.replace(/^\?/, '')
    const tab = new URLSearchParams(q).get('tab')
    if (tab === 'ai-audit') return 'Отладка · AI аудит'
    if (tab === 'failed-deliveries') return 'Отладка · Недоставленные'
    return 'Отладка'
  }

  if (pathname === '/analytics') {
    const q = sp.startsWith('?') ? sp.slice(1) : sp.replace(/^\?/, '')
    const tab = new URLSearchParams(q).get('tab')
    const labels: Record<string, string> = {
      reviews: 'Отзывы',
      operators: 'Операторы',
      tags: 'Метки',
      'ai-ops': 'Мозгобот',
      slow: 'Зависшие',
    }
    return tab && labels[tab] ? `Аналитика · ${labels[tab]}` : 'Аналитика'
  }

  if (/^\/projects\/[^/]+\/ai-assistant$/.test(pathname)) {
    return 'AI ассистент проекта'
  }

  if (pathname === '/settings') {
    const q = sp.startsWith('?') ? sp.slice(1) : sp.replace(/^\?/, '')
    const params = new URLSearchParams(q)
    const tab = params.get('tab')
    const pt = params.get('pt')
    const labels: Record<string, string> = {
      workspace: 'Рабочее пространство',
      roles: 'Роли',
      projects: 'Проекты',
      triggers: 'Триггеры',
      macros: 'Макросы',
      loadtest: 'Нагрузка Мозгобота',
    }
    const ptLabels: Record<string, string> = {
      general: 'Проект · общее',
      fields: 'Проект · поля',
      tags: 'Проект · метки',
      rules: 'Проект · правила',
      templates: 'Проект · шаблоны',
      channels: 'Проект · каналы',
      anomalies: 'Проект · аномалии',
      identifiers: 'Проект · идентификаторы',
      ai: 'Проект · Мозгобот',
    }
    if (tab === 'projects' && pt && ptLabels[pt]) return `Настройки · ${ptLabels[pt]}`
    if (tab && labels[tab]) return `Настройки · ${labels[tab]}`
    return 'Настройки'
  }

  if (/^\/tickets\/[^/]+$/.test(pathname)) {
    return 'Обращение'
  }

  if (pathname === '/schedules') {
    const q = sp.startsWith('?') ? sp.slice(1) : sp.replace(/^\?/, '')
    const tab = new URLSearchParams(q).get('tab')
    if (tab === 'analysis') return 'Табель · Анализ'
    return 'Табель'
  }

  return ROUTE_TITLES[pathname] || pathname.replace(/^\//, '') || 'Страница'
}

export function parseRouteTo(to: string): { pathname: string; search: string } {
  const normalized = to.startsWith('/') ? to : `/${to}`
  const q = normalized.indexOf('?')
  if (q === -1) return { pathname: normalized, search: '' }
  return {
    pathname: normalized.slice(0, q),
    search: normalized.slice(q),
  }
}

export function buildRoutePath(pathname: string, search: string): string {
  return `${pathname}${search || ''}`
}
